import AppDispatcher from '../dispatcher/AppDispatcher';
import AuthConstants from '../constants/AuthConstants';
import { EventEmitter } from 'events';

const CHANGE_EVENT = 'change';

function setUser(user) {
  if (!localStorage.getItem('odoo_user_id')) {
    localStorage.setItem('odoo_user_id', user.id);
    localStorage.setItem('odoo_user_name', user.name);
    localStorage.setItem('odoo_user_login', user.login);
    localStorage.setItem('odoo_user_password', user.password);
  }
}

function removeUser() {
  localStorage.removeItem('odoo_user_id');
  localStorage.removeItem('odoo_user_name');
  localStorage.removeItem('odoo_user_login');
  localStorage.removeItem('odoo_user_password');
}

class AuthStoreClass extends EventEmitter {
  _invalid: false

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback)
  }

  isAuthenticated() {
    if (localStorage.getItem('odoo_user_id')) {
      return true;
    }
    return false;
  }

  getUser() {
    return {
      'id': localStorage.getItem('odoo_user_id'),
      'name': localStorage.getItem('odoo_user_name'),
      'login': localStorage.getItem('odoo_user_login'),
      'password': localStorage.getItem('odoo_user_password')
    }
  }
}

const AuthStore = new AuthStoreClass();

// Here we register a callback for the dispatcher
// and look for our various action types so we can
// respond appropriately
AuthStore.dispatchToken = AppDispatcher.register(action => {

  switch(action.actionType) {

    case AuthConstants.LOGIN_USER:
      AuthStore._invalid = false;
      setUser(action.user);
      AuthStore.emitChange();
      break

    case AuthConstants.LOGOUT_USER:
      removeUser();
      AuthStore.emitChange();
      break

    case AuthConstants.LOGIN_USER_ERROR:
      AuthStore._invalid = true;
      AuthStore.emitChange();

    default:
  }

});

export default AuthStore;



// WEBPACK FOOTER //
// ./src/stores/AuthStore.js